const postCloneChecklist = {
  toastr: 'Cloned Checklist',
  toastr1: 'The Model has been updated successfully',
  toastrError: 'Name already registered',
  toastrError1: 'Enter another name',
  toastr1Error: 'Empty checklist',
  toastr1Error1: 'Insert checklist questions before cloning'
};

export default postCloneChecklist;
